export const CONTAINER_COLORS = {
  GREOSAUT: '#feffe5',
  OSGER: '#E5FFE8',
  AGUANA: '#feffe5',
  AGUCONLOG: '#feffe5',
  PEDAGE: '#E5FFE8',
  GERPEDAUT: '#feffe5',
  RENDATCLI: '#feffe5',
  ERRINT: '#feffe5',
  SNOREC: '#ffe7e5',
  ERRO: '#ffe7e5',
} as any;

export const ICON_COLORS = {
  APROVADO: '#75B943',
  AGEREA: '#75B943',
  GREOSAUT: '#FDC441',
  OSGER: '#75B943',
  AGUANA: '#FDC441',
  AGUCONLOG: '#FDC441',
  PEDAGE: '#75B943',
  FECHAR: '#75B943',
  GERPEDAUT: '#FDC441',
  AGUTRA: '#FDC441',
  RENDATCLI: '#FDC441',
  SOLATE: '#75B943',
  CANEA: '#FDC441',
  ERRINT: '#FDC441',
  SNOREC: '#e34e2a',
  CANREA: '#e34e2a',
  ERRO: '#e34e2a',
} as any;
